module.exports = __webpack_public_path__ + "19e13db9eff30ef23756dab03da4fa6b.svg";